module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-contracts/postedinvoices/postedinvoices.component.scss
// module id = ./src/app/pages/client/my-contracts/postedinvoices/postedinvoices.component.scss
// module chunks = main